import React, { useContext } from 'react'
import "./style.scss"
import { AuthContext } from "../../../context/auth";
import { deleteTeamMember } from '../../../api';
const Index = ({ setDeleteModal, setOpenAddMemberModal, reset, selectedMember, fetchTeamsRole }) => {
    const { setNotification, setIsLoading } = useContext(AuthContext)


    return (
        <div className="small-modal-wrapper">
            <div className="delete-modal-content">
                <div style={{position:'relative', justifyContent:'center', display:'flex', width:'100%'}}>
                <i className='fal fa-times close' style={{ color: '#9a9a9a', position: 'absolute', right: '0px', top: '0px', cursor: 'pointer', zIndex: 9, fontSize: '20px' }} onClick={() => {
                    setDeleteModal(false)
                }}></i>
                <span style={{ width: '44px', height: '44px', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '12px', background: '#DC1E00', color: 'var(--white)' }}>
                    <i class="fal fa-trash-alt"></i>
                </span>
                </div>
                <h2>Are you sure?</h2>
                <p>You are about to delete this team member.</p>
                <button className='btn' onClick={() => {
                    setIsLoading(true)
                    deleteTeamMember(selectedMember.id).then(() => {
                        fetchTeamsRole()
                        setDeleteModal(false)
                        setOpenAddMemberModal(false)
                        reset()
                        setIsLoading(false)
                        setNotification({
                            message: "Member Deleted.",
                            type: "delete"
                        })
                    }).catch(err => {
                        setNotification({
                            message: "Something went wrong.",
                            type: "red"
                        })
                        setIsLoading(false)
                    })
                }}>Delete Team Member</button>
                <button className='btn transparent' onClick={() => {
                    setDeleteModal(false)
                }}>Cancel</button>
            </div>
        </div>
    )
}

export default Index